angular.module('dealerware.web.data').factory('DealerwareEmployeeModel', function ($http,Model,$q,DataUtils) {
    var model = new Model({
        baseEndpoint: '/locations/:location_id/users',
        actionOverrides: {
            create: {
                endpoint: '/locations/:location_id/users/dealer',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            update: {
                endpoint: '/locations/:location_id/users/:id/update_and_confirm',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            }
        },
        rootNode: 'user',
        requestTransforms: new function() {

            this.cleanData = function(args, data,isUpdate) {
                delete data.id;
                delete data.auth_token;
            };

            this.create = function(args, data) {
                this.cleanData(args, data);
            };

            this.update = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    id: origData.id,
                    email: origData.email,
                    user_profile_attributes: {
                        first_name: origData.user_profile_attributes.first_name,
                        last_name: origData.user_profile_attributes.last_name,
                        phone_number: origData.user_profile_attributes.phone_number
                    }
                });
            };

            this.setPasswordAndConfirm = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    confirmation_token: origData.confirmation_token,
                    password: origData.password
                });
            };

            this.changePassword = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    id: origData.id,
                    password: origData.password,
                    password_confirmation: origData.password_confirmation
                });
            };

            this.manuallyConfirm = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, { id: origData.id });
            };
        },
        responseTransforms: new function() {

            this.get = function(args, data) {

                // Some attributes need special formatting before page display.
                //
                if (data.user_profile) {
                    data.user_profile_attributes = { };

                    // Phone number needs normalization to (nnn) nnn-nnnn.
                    //
                    angular.extend(data.user_profile_attributes, data.user_profile, {
                        phone_number: DataUtils.getInstance().normalizePhoneNumber(
                            data.user_profile.phone_number
                        )
                    });
                    delete data.user_profile;
                }
            };
        },
        customActions: {
            get: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/:id',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            getByConfirmationToken: {
                method: 'GET',
                endpoint: '/users/confirm',
                params: { include_user_profile: true },
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            getRoles: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/:id/roles',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            setPasswordAndConfirm: {
                method: 'POST',
                endpoint: '/users/confirm',
                params: { include_user_profile: true },
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            resetPassword: {
                method: 'POST',
                endpoint: '/users/reset_password',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            enroll: {
                method: 'PUT',
                endpoint: '/locations/:location_id/users/dealer',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            changePassword: {
                method: 'PUT',
                endpoint: '/locations/:location_id/users/:id/password',
                rootNodeRequest: 'user',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            manuallyConfirm: {
                method: 'POST',
                endpoint: '/locations/:location_id/users/:id/confirm',
                ignoreDefaultRootNodeRequest: true,
                isCollection: true,
                ignoreDefaultParams: true,
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            loadServiceAdvisors: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/roles/service_advisors',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true,
                params: { include_user_profile: true }
            },
            getServiceAdvisorStatistics: {
                method: 'GET',
                endpoint: '/locations/:location_id/dashboard/service_advisors',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            clearActivationRequired: {
                method: 'PUT',
                endpoint: '/locations/:location_id/users/:id/clear_activation_required',
                ignoreDefaultRootNode: true,
                ignoreAssociations: true
            },
            deactivate: {
                method: 'DELETE',
                endpoint: '/locations/:location_id/users/:id'
            },
            activate: {
                method: 'POST',
                endpoint: '/locations/:location_id/users/:id/activate',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            }
        }
    });

    jQuery.extend(model.prototype,{
        changePassword: function() {
            var deferred = $q.defer();
            this.$changePassword({
                successCallback: function(returnValue,response) {
                    deferred.resolve(returnValue,response);
                },
                errorCallback: function(response) { deferred.reject(response); }
            });
            return deferred.promise;
        },
        getEmployeeFullName: function() {
            return (this.hasOwnProperty('data') && angular.isObject(this.data) && this.data.hasOwnProperty('user_profile_attributes') && angular.isObject(this.data.user_profile_attributes) && this.data.user_profile_attributes.hasOwnProperty('full_name')) ? this.data.user_profile_attributes.full_name : undefined;
        },
        hasRole: function(role){
            var hasRole = false;
            if (role && isArray(role)) {
                var self = this;
                $.each(role,function(idx,val){
                    hasRole = self.inRole(val);
                    if (hasRole) { return false; }
                });
            } else {
                hasRole = this.inRole(role);
            }
            return hasRole;
        },
        inRole: function(role) {
            var inRole = false;
            var _self = this;
            if (this.data.roles_mapped && isArray(this.data.roles_mapped)) {
                $.each(this.data.roles_mapped,function(idx,val){
                    if ( val.name == 'superuser1' || val.name == role ) {
                        inRole = true;
                        return false;
                    }
                });
            }
            return inRole;
        },
        searchDisplay: function() {
            var s;
            if (this.data && isObject(this.data)) {
                if (this.data.hasOwnProperty('user_profile_attributes') && this.data.user_profile_attributes) {
                    var name = this.data.user_profile_attributes.full_name;
                    var phone = this.data.user_profile_attributes.phone_number;
                    s = phone ? name + ' ' + this.data.user_profile_attributes.phone_number : name;
                    if (!s) { s = this.data.email; }
                } else {
                    s = this.data.email;
                }
            }
            return s;
        },
        isComplete: function() {
            var complete = true;
            if ( !this.data.hasOwnProperty('email') || !this.data.email ) {
                complete = false;
            } else {
                if ( !this.data.hasOwnProperty('user_profile_attributes') || !(isObject(this.data.user_profile_attributes)) ) {
                    complete = false;
                } else {
                    if ( !( this.data.user_profile_attributes.hasOwnProperty('full_name') ) || !this.data.user_profile_attributes.full_name ) {
                        complete = false;
                    }
                }
            }
            return complete;
        },
        toSummaryString: function() {
            var s;
            if (this.data && isObject(this.data) && this.data.hasOwnProperty('user_profile_attributes') && isObject(this.data.user_profile_attributes)) {
                var name = this.data.user_profile_attributes.full_name;
                var phone = this.data.user_profile_attributes.phone_number;
                s = phone ? name + '<br>' + phone : name;
            }
            return s;
        },
        isRequired: function() {
            return !this.isComplete();
        }
    });

    return model;
});
